import jsgc from './jsgc';
import zfcg from './zfcg';
export default {
    path: 'zhongbiaogg',
    component: () => import(/*webpackChunkName: 'bidding-dingbiao'*/ '@layout/empty'),
    children: [
        jsgc,
        zfcg
    ]
}